import base from "./base";
import { addErrorNotification } from "../utils/notifications";

base.options = {
	headers: {
		// "Content-Type": "multipart/form-data"
		"Content-Type": "application/json"
	}
};
export const postSubscribe = formData => {
	return base.post("/subscribe/", formData).catch(() => {
		addErrorNotification("Unable to subscribe");
	});
};

export const postVerifySubscribe = data => {
	return base.put("/subscribe/verify", data).catch(() => {
		addErrorNotification("Unable to verify subscription");
	});
};

export const postUnsubscribe = formData => {
	console.log("UNSUB");
	console.log("formData", formData);
	return base.post("/subscribe/remove", formData);
};



// WEBPACK FOOTER //
// ./src/services/subscribe.js